import i18next from "i18next";
import {
  Background,
  ButtonsContainer,
} from "../addClientModal/addClientModal.styles";
import {
  ModalTitle,
  ModalMessage,
  ConfirmButton,
  CancelButton,
} from "./confirmationModal.styles";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

type ConfirmationModalProps = {
  title: string;
  message: string;
  onConfirm: (() => void) | any;
  closeConfirmationModal: () => void;
  isLoading?: boolean;
  color?: string;
  isShown?: boolean;
  strict?: boolean;
  warning?: string;
  className?: string;
  input?: (value: string) => void;
  inputLabel?: string;
};

const ConfirmationModal = ({
  title,
  message,
  onConfirm,
  closeConfirmationModal,
  isLoading = false,
  color = "#973131",
  isShown = false,
  strict,
  warning,
  className,
  input,
  inputLabel,
}: ConfirmationModalProps) => {
  const [confirmValue, setConfirmValue] = useState<string>("");
  const strictInputRef = useRef<HTMLInputElement>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (isShown) strictInputRef.current?.focus();
  }, [isShown]);

  return (
    <Background
    className={`${className}`}
      style={{
        opacity: isShown ? "1" : "0",
        pointerEvents: isShown ? "all" : "none",
        zIndex: "99999",
      }}
    >
      <form
        className="flex flex-col justify-around rounded-xl bg-background p-8 min-h-[300px] min-w-[35rem] max-w-[45rem] bg-white"
        onSubmit={(e: any) => e.preventDefault()}
      >
        <ModalTitle className="!text-4xl !mb-0">{title}</ModalTitle>
        {!strict && <ModalMessage>{message}</ModalMessage>}
        {strict && (
          <>
            <p>
              {i18next.language === "en"
                ? 'To confirm, type "yes" in the box below'
                : 'للتأكيد اكتب "نعم" في حقل الادخال'}
            </p>
            {warning && <p className="text-red-600 font-bold">{warning}</p>}
            <input
              onChange={(e) => setConfirmValue(e.target.value)}
              className="border rounded-md p-4 py-2"
              type="text"
              placeholder='To confirm, Write "yes" here please'
              value={confirmValue}
              ref={strictInputRef}
            />
          </>
        )}
        {input && (
          <div className="flex flex-col gap-2">
            {inputLabel && (
              <p className="text-sm text-gray-500">{inputLabel}</p>
            )}
            {input && (
              <input
                onChange={(e) => input(e.target.value)}
                className="border rounded-md p-4 py-2"
                type="text"
                placeholder={inputLabel || ""}
                name={inputLabel || ""}
              />
            )}
          </div>
        )}
        <ButtonsContainer className="!mt-0">
          <ConfirmButton
            onClick={() => {
              onConfirm();
              setConfirmValue("");
            }}
            disabled={
              (strict === true &&
                confirmValue.toLowerCase() !== "yes" &&
                confirmValue.toLowerCase() !== "نعم") ||
              isLoading
                ? true
                : false
            }
            isLoading={isLoading}
            style={{ backgroundColor: color }}
            className="disabled:!opacity-50 disabled:!cursor-not-allowed"
          >
            {i18n.language === "ar" ? "نعم" : "Yes"}
          </ConfirmButton>
          <CancelButton
            onClick={() => {
              closeConfirmationModal();
              setConfirmValue("");
            }}
          >
            {i18n.language === "ar" ? "لا" : "No"}
          </CancelButton>
        </ButtonsContainer>
      </form>
    </Background>
  );
};
export default ConfirmationModal;
